import { render } from "./EditCountry.vue?vue&type=template&id=5e3e50f8&scoped=true"
import script from "./EditCountry.vue?vue&type=script&lang=js"
export * from "./EditCountry.vue?vue&type=script&lang=js"

import "./EditCountry.vue?vue&type=style&index=0&id=5e3e50f8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5e3e50f8"

export default script